module.exports = __webpack_public_path__ + "media/images/steps/svg/job-search-66faf18801a5b2693f413c49bf2fa478.svg";